var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.093 9.73393L21.283 0H19.3422L12.2308 8.45183L6.55101 0H0L8.58902 12.7807L0 22.9882H1.94088L9.45067 14.0628L15.449 22.9882H22L13.0925 9.73393H13.093ZM10.4347 12.8933L9.56444 11.6206L2.6402 1.49386H5.62127L11.2092 9.66647L12.0795 10.9391L19.3431 21.5623H16.3621L10.4347 12.8938V12.8933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_1919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.cc32e41760fa71a33cd19dab80cc32f7.svg";
export { ForwardRef as ReactComponent };